<template>

  <v-autocomplete v-model="clubID"
                  :label="label || 'Club'"
                  :placeholder="placeholder"
                  :items="clubs"
                  item-text="alias"
                  item-value="id"
                  :clearable="true"
                  :no-filter="true"
                  :loading="loading"
                  :disabled="isDisabled"
                  hide-no-data="hide-no-data"
                  :search-input.sync="textInput">
    <template slot="item" slot-scope="{ item }">
      <v-list-tile-content>
        <div class="club-container">
          <div class="club-logo-container">
            <img class="club-logo-img" v-if="!item.logoURL" src="../../../static/icons/club-icon-256x256-darkblue.png"/>
            <img class="club-logo-img" v-if="item.logoURL" :src="item.logoURL"/>
          </div>
          <p class="club-name">{{ item.alias }} - <b class="item-text-small">{{ getSportName(item.sportID) }}</b> - <b class="item-text-small" v-if="item.regionName">{{ item.regionName }}</b></p>
        </div>
      </v-list-tile-content>
    </template>
  </v-autocomplete>

</template>

<script>

import { getSportInfos } from '../../helpers/get-sport-infos'

export default {
  name: 'NEWClubSelector',
  props: [
    'currentClubID',
    'sportID',
    'label',
    'disabled',
    'disabledText'
  ],
  data () {
    return {
      loading: false,
      clubs: [],
      clubID: '',

      textInput: '',

      preventNextSearch: false
    }
  },
  mounted () {
    if (this.currentClubID) {
      this.setCurrentClub()
    }
  },
  methods: {
    handleInput (input) {
      this.loading = false
      this.textInput = input
      setTimeout(() => {
        if (input && (this.textInput === input)) {
          this.loading = true
          this.loadClubs()
        }
      }, 400)
    },
    setCurrentClub () {
      this.loading = true
      this.$store.dispatch('getClub', this.currentClubID)
        .then(resp => {
          this.preventNextSearch = true
          this.clubs = [resp]
          this.clubID = this.currentClubID
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading club')
          this.loading = false
        })
    },
    loadClubs () {
      if (this.preventNextSearch) {
        this.loading = false
        this.preventNextSearch = false
        return
      }

      let searchparams = {
        name: this.textInput
      }
      if (this.sportID) {
        searchparams.sportID = this.sportID
      }

      this.$store.dispatch('fetchClubs', searchparams)
        .then(resp => {
          this.clubs = resp.items
          this.loading = false
        })
        .catch(() => {
          console.error('Error loading clubs')
          this.loading = false
        })
    },
    getSportName (sportid) {
      return getSportInfos({id: sportid}).names['default']
    },
    clear () {
      this.clubID = ''
      this.clubs = []
    }
  },
  computed: {
    isDisabled () {
      return this.disabled || false
    },
    placeholder () {
      return this.isDisabled ? (this.disabledText || '') : (this.label || 'Club')
    }
  },
  watch: {
    'textInput' () {
      if (this.textInput) {
        this.handleInput(this.textInput)
      } else {
        this.clubs = []
      }
    },
    'sportID' () {
      this.clear()
    },
    'clubID' () {
      this.$emit('clubSelected', this.clubID || '')
    },
    'currentClubID' () {
      if (this.currentClubID) {
        this.setCurrentClub()
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  .item-text-small {
    font-size: 11px;
  }

  .club-container {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 12px;
  }

  .club-logo-container {
    align-self: center;
    width: 30px;
    height: 30px;
    border: 1px solid #cccccc;
    border-radius: 50%;
    display: grid;
  }

  .club-logo-img {
    max-width: 18px;
    max-height: 18px;
    justify-self: center;
    align-self: center;
  }

  .club-name {
    align-self: center;
    font-size: 13px;
    margin-bottom: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/NEWClubSelector.vue